export default __webpack_public_path__ + "static/media/waves.db76cd91.svg";